export default __webpack_public_path__ + "static/media/050-modern art.ec0188a0.svg";